/* @ngInject */
export class MessageController {
  /* @ngInject */
  constructor ($scope, $q) {
    this.$scope = $scope
    this.$q = $q
  }

  $onInit() {

    console.log('MessageController : init')

    this.isVisible = false
    this.messageData = null

    this.onMessageChange = this.onMessageChange.bind(this) 
    this.onMessageChangeVisibility = this.onMessageChangeVisibility.bind(this) 

    // resource == binding vers SimulatorController.messageMouvements
    this.watcher1 = this.$scope.$watch('MessageController.resource', this.onMessageChange)
    this.watcher2 = this.$scope.$watch('MessageController.resource.visibility', this.onMessageChangeVisibility)

    }

/** 
*
Principes de visibilité des messages d'info. La visibilité est une propriété du message
Par exemple, le click sur bouton "i" des panels; déclenche le toggle des messages
Le toggling des messages est réalisé par la simple modification de la propriété de visibilité
Dans le MessageController (ici), on observe en plus du changement de message, le changement de sa visibilité
Attention à ne pas déclencher un traitement récursif  si par exemple on affecte messageData.visibility lors du traitement de onMessageChangeVisibility 
*
*/
  


/**
* Nouveau message à traiter
*/
  onMessageChange(newResource, oldResource) {
    
    this.messageData = newResource

    console.log('onMessageChange in ', this.panel, newResource)

    // invalide ou vide, on masque le container de msg
    if(!(this.messageData && this.messageData.message)) {
      this.hide()
      return
    }
    this.setNavigationVisibility()

    this.show()  
    var txt = this.messageData.message

  }

/**
* La visibilité du message est controlée de l'extérieur (entre autre par les boputons 'i' dans les panels)
* Donc on 'transporte' la visibilité dans les messages eux-mêmes (qui sont gérés dans SimulatorConroller)
*/
  onMessageChangeVisibility() {
    if(this.notEmpty())  
        this.isVisible = this.messageData.visibility 
    else  
        this.isVisible = false
    
  }
  


/**
*/
close() {
  this.hide()
}   

/*
* 
*/  
hide() {
  if(!this.messageData) {
    this.isVisible = false
    return;
  }
  //this.messageData.visibility = this.isVisible = false
  this.messageData.visibility = false
}

/*
* Au click sur le contexte du message, au scrolle vers le panel correspondant
*/
navigate() {
    if(this.messageData.context) {
        var leContexte = new Object();
        leContexte.panel = this.messageData.context;
        leContexte.data = null;
        leContexte.subData = null;
        this.parentSimulator.smoothScrollToPanel(leContexte);
    }
    this.close();
}

/**
* Bretelles : ne pas faire afficher un message vide
*/
notEmpty() {
  return (this.messageData) && (this.messageData.message) && (this.messageData.message != '')
}

/**
* Détermine si on doit mettre un lien pour scroller vers un panel
* Pas de lien si le message affiché dans ce panel, concerne ce même panel
*/
setNavigationVisibility() {

    var context = null
    if ((typeof(this.messageData.context) != 'undefined') && (this.messageData.context != null)) {
        context = this.messageData.context.panel
    }
    if (typeof(context) == 'undefined') {
        context = this.messageData.context
    }
  //this.navigationVisible = (this.messageData.context != this.panel) && (this.messageData.context != null)
  this.navigationVisible = (context != this.panel) && (context != null)
} 

/**
*/
show() {
  //this.messageData.visibility = this.isVisible = true
  this.messageData.visibility = true
}







}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/Message/message.controller.js